module.exports = "/_next/static/images/b33a460cb976ffab6c24791e7f5918c6-secured-icon.svg.webp";